import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, inject } from '@angular/core';
import { Fridge } from '../../models/Fridge';
import { FridgeSubSystemState } from 'package-types/index';
import { UserService } from 'src/app/services/user/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-fridge-list',
  templateUrl: './fridge-list.component.html',
  styleUrls: ['./fridge-list.component.scss'],
  standalone: false,
})
export class FridgeListComponent implements OnInit, OnChanges, OnDestroy {
  userService = inject(UserService);

  @Input('fridge') fridge: Fridge;
  @Output() selectFridge: EventEmitter<string> = new EventEmitter();
  merchantName = '';
  private merchantsSubscription: Subscription;

  constructor() {
    this.merchantsSubscription = this.userService.merchantsChange.subscribe(() => {
      this.updateMerchantName();
    });
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fridge) {
      this.updateMerchantName();
    }
  }

  ngOnDestroy(): void {
    this.merchantsSubscription?.unsubscribe();
  }

  onFridgeSelect(id: string | undefined) {
    this.selectFridge.emit(id);
  }

  get tabletVersion(): string {
    if (!this.userService.isAuthenticated || !this.userService.isInternal) {
      return '';
    }
    // both parts of the version are always the same, e.g. "91.91"
    return this.fridge?.tabletInfo?.version?.split('.')[0] || '';
  }

  private updateMerchantName(): void {
    if (!this.fridge) {
      this.merchantName = '';
      return;
    }
    const merchants = this.userService.merchants || [];
    this.merchantName =
      merchants.find((m) => m?._id === (this.fridge.merchantId as unknown as string))?.name || '';
  }

  protected readonly FridgeSubSystemState = FridgeSubSystemState;
}
